module.exports = __webpack_public_path__ + "static/interview_map_03_ja-d2d931bc0ef88b707778027ec8f370d0.svg";